import { ChildRef } from '../../../../../lib/web/components/child-ref';
import { ChildrenRef } from '../../../../../lib/web/components/children-ref';
import { Component } from '../../../../../lib/web/components/component';
import { ComponentBase } from '../../../../../lib/web/components/component-base';
import { EventListener } from '../../../../../lib/web/components/event-listener';
import { Str } from '../../../../../lib/web/core/str';
import { SessionService } from '../../../services/session.service';

@Component({
    selector: '.p-last-releases'
})
export class LastReleasesComponent extends ComponentBase<HTMLElement> {

    @ChildrenRef(HTMLDivElement, '.p-last-releases__content-tab')
    private _tabs: HTMLDivElement[] = null;
    
    public constructor(node: HTMLElement, private _sessionService: SessionService) {
        super(node);
    }

    public onInit(mode?: 'load' | 'redirect'): void {
        super.onInit(mode);        
    } 
    
    @EventListener('selection-changed', '.a-tab')
    public onTabSelectionChanged(e: CustomEvent): void {
        this.setSelectedTab(e.detail.id);
    }

    private setSelectedTab(id: string): void {
        this._tabs.forEach((tab: HTMLDivElement) => {
            tab.classList.add('u-hidden');
        });
        this._node.querySelector<HTMLDivElement>(`.p-last-releases__content-tab--${Str.camelToKebab(id)}`).classList.remove('u-hidden');
        this.replaceState(`${location.pathname}?tab=${Str.camelToKebab(id)}`);
    }
}